var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.414,
    height: 22,
    viewBox: "0 0 22.414 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #afbbc6;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "paperclip",
    className: "cls-1",
    d: "M22,10.764l-9.456,8.918a6.443,6.443,0,0,1-8.735,0,5.594,5.594,0,0,1,0-8.238l9.456-8.918a4.3,4.3,0,0,1,5.824,0,3.729,3.729,0,0,1,0,5.492L9.624,16.935a2.148,2.148,0,0,1-2.912,0,1.865,1.865,0,0,1,0-2.746L15.448,5.96",
    transform: "translate(-1.002 -0.388)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paperClip.ca040f73f29cea168352fa768f5756b1.svg";
export { ForwardRef as ReactComponent };